<onyx-section [heading]="`${I18N}.heading`">
  <div rightHeading class="heading">
    <onyx-toggle
      [disabled]="isRequired()"
      [checked]="showForm() || isRequired()"
      (checkedChange)="showForm.set($event)"
    ></onyx-toggle>

    <div class="information">
      <onyx-icon name="tooltip-filled" [size]="16"></onyx-icon>

      <p>
        {{ `${I18N}.requiredFor` | translate }}
        {{ categoriesRequireDriverCardLabel() }}
      </p>
    </div>
  </div>

  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-text-field
      [formControl]="controls.number"
      label="labels.number"
      textTransform="uppercase"
      [size]="32"
    ></onyx-text-field>

    <onyx-dropdown
      [formControl]="controls.issuingCountry"
      label="labels.issuingCountry"
      [options]="countries$ | async"
      [search]="true"
      [size]="32"
    ></onyx-dropdown>

    <onyx-datepicker
      [formControl]="controls.expirationDate"
      label="labels.expirationDate"
      [yearsRange]="{ past: 0, future: 10 }"
      [warningTypes]="['pastDate']"
      [size]="32"
    ></onyx-datepicker>

    <onyx-upload
      [formControl]="controls.scans"
      label="labels.driverCardScan"
      [limit]="2"
      [size]="32"
    ></onyx-upload>
  </form>
</onyx-section>
